import {DataClient} from "../../client/DataClient"


import {AsyncComponentP} from "../common/AsyncComponent";
import {UploadFormat} from "./UploadFormat";

export interface UploadFormatPageProps {
    dataClient: DataClient
}
export const HalfHourlyConsumptionUploadFormatPage = ({ dataClient }: UploadFormatPageProps) =>
    <AsyncComponentP loaderFunction={dataClient.getFormatsForUpload.bind(dataClient)} dataPropName={'formats'}>
        <UploadFormat formats={[]}/>
    </AsyncComponentP>


export const BucketMappingUploadFormatPage = () => {
    return <UploadFormat formats={[{headerFields: ['mpan']}]}/>;
}
